export enum UserSegmentLabel {
  Anonymous = 'Anonymous',
  Prospect = 'Prospect',
  Normal = 'Normal',
  PendingChurn = 'Pending-churn',
  Dunning = 'Dunning',
  Churned = 'Churned',
}
